import React, { useState, useEffect, useRef } from 'react';
import { TextField, Paper, List, ListItem, ListItemText, ClickAwayListener } from '@material-ui/core';

const EmailAutocompleteField = ({ input, meta, usersOptions = [], ...rest }) => {
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [isSelectingSuggestion, setIsSelectingSuggestion] = useState(false);
  const inputRef = useRef(null);

  const extractEmailFromLabel = (label) => {
    const emailMatch = label.match(/ - (.+@.+\..+)$/);
    return emailMatch ? emailMatch[1] : null;
  };

  useEffect(() => {
    if (input.value && input.value.length > 0) {
      const emailSuggestions = usersOptions
        .map(option => extractEmailFromLabel(option.label))
        .filter(email => email && email.toLowerCase().includes(input.value.toLowerCase()))
        .slice(0, 5);
      
      setFilteredSuggestions(emailSuggestions);
      setShowSuggestions(emailSuggestions.length > 0 && input.value !== emailSuggestions[0]);
    } else {
      setShowSuggestions(false);
      setFilteredSuggestions([]);
    }
  }, [input.value, usersOptions]);

  const handleSuggestionClick = (email) => {
    setIsSelectingSuggestion(true);
    input.onChange(email);
    setShowSuggestions(false);
    // Reset the flag after a short delay to allow the form to process the change
    setTimeout(() => {
      setIsSelectingSuggestion(false);
    }, 100);
  };

  const handleClickAway = () => {
    setShowSuggestions(false);
  };

  const hasError = meta.touched && meta.error && !isSelectingSuggestion;

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div style={{ position: 'relative', width: '100%' }}>
        <TextField
          {...input}
          {...rest}
          ref={inputRef}
          fullWidth
          variant="outlined"
          size="small"
          error={hasError}
          helperText={hasError ? 'Invalid email' : ''}
          onFocus={() => {
            if (filteredSuggestions.length > 0) {
              setShowSuggestions(true);
            }
          }}
          InputProps={{
            style: {
              fontSize: 16,
              height: 40
            }
          }}
          style={{
            backgroundColor: 'white',
            borderRadius: 4
          }}
        />
        
        {showSuggestions && (
          <Paper
            style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              right: 0,
              zIndex: 1000,
              maxHeight: 200,
              overflow: 'auto',
              marginTop: 4
            }}
            elevation={3}
          >
            <List dense>
              {filteredSuggestions.map((email, index) => (
                <ListItem
                  key={index}
                  button
                  onMouseDown={() => setIsSelectingSuggestion(true)}
                  onClick={() => handleSuggestionClick(email)}
                  style={{
                    borderBottom: index < filteredSuggestions.length - 1 ? '1px solid #f0f0f0' : 'none',
                    minHeight: 40
                  }}
                >
                  <ListItemText
                    primary={email}
                    primaryTypographyProps={{
                      style: { fontSize: 16 }
                    }}
                  />
                </ListItem>
              ))}
            </List>
          </Paper>
        )}
      </div>
    </ClickAwayListener>
  );
};

export default EmailAutocompleteField; 